export interface Department {
  char: string;
  name: string;
  name_nl: string;
  show: boolean;
}

// prettier-ignore
export const knownDepartments: Department[] = [
  { char: 'W', name: 'Water',        name_nl: 'Water',        show: true  },
  { char: 'K', name: 'Greenhouse',   name_nl: 'Kassenbouw',   show: true  },
  { char: 'E', name: 'Electrical',   name_nl: 'Elektro',      show: true  },
  { char: 'V', name: 'Heating',      name_nl: 'Verwarming',   show: true  },
  { char: 'S', name: 'Service',      name_nl: 'Service',      show: true  },
  { char: 'C', name: 'Climate Cell', name_nl: 'Klimaatcel',   show: true  },
  { char: 'R', name: 'R&D',          name_nl: 'R&D',          show: false },
  { char: 'Q', name: 'PBI Projects', name_nl: 'PBI Projects', show: false },
  { char: 'M', name: 'Warehouse',    name_nl: 'Magazijn',     show: false },
  { char: 'P', name: 'Projects',     name_nl: 'Projects',     show: false },
  { char: 'Z', name: 'Russia',       name_nl: 'Rusland',      show: false },
  { char: 'U', name: 'Certhon USA',  name_nl: 'Certhon USA',  show: false },
  { char: 'T', name: 'Tech.Autom.',  name_nl: 'Techn.Autom.', show: false },
  { char: 'N', name: 'Certhon CAN',  name_nl: 'Certhon CAN',  show: false },
  { char: 'H', name: 'Hungary',      name_nl: 'Hongarije',    show: false },
  { char: 'Y', name: 'Export BI',    name_nl: 'Export BI',    show: false },
  { char: 'J', name: 'Indirect BI',  name_nl: 'Indirect BI',  show: false },
  { char: 'I', name: 'Indirect',     name_nl: 'Indirect',     show: false },
  { char: 'O', name: 'Service BI',   name_nl: 'Service BI',   show: false },
  { char: 'B', name: 'Belgium',      name_nl: 'Belgie',       show: false },
  { char: 'X', name: 'Cost Work',    name_nl: 'Kostenwerk',   show: false },
];

/**
 * Get the display label for a department char code
 * @param char - Single-letter department code
 * @param locale - Language for the label ('en' or 'nl')
 * @returns Human-readable department name or the char code if unknown
 */
export function getDepartmentLabel(
  char?: string,
  locale: 'en' | 'nl' = 'nl',
): string {
  if (!char) return '-';
  const dept = knownDepartments.find((d) => d.char === char);
  if (!dept) return char; // Fallback to char if unknown
  return locale === 'nl' ? dept.name_nl : dept.name;
}
